class SeatplansEditCtrl {
    constructor($http, Env, Error, $stateParams, $state, locale, SweetAlert, model, Restangular, NavService) {
        this.api = $http;
        this.env = Env;
        this.error = Error;
        this.stateParams = $stateParams;
        this.state = $state;
        this.locale = locale;
        this.sweetAlert = SweetAlert;
        this.model = model;
        this.restAngular = Restangular;
        this.navService = NavService;

        this.groups = this.model.groups.data;
        delete this.model.groups;
        this.groupsToDelete = [];
        this.currentView = 'general';
        this.updateNavigationInformation();
    }

    save() {
        this.model.save().then((seatplan) => {
            this.model = seatplan;
            let eventToDoAfter = null;

            for (let i = 0; i < this.groups.length; i++) {
                let curGroup = this.groups[i];
                if (curGroup.id) {
                    eventToDoAfter = this.restAngular.all('seatplans/groups').customPUT(curGroup, curGroup.id);
                } else {
                    this.api.post(this.env.apiUrl + '/seatplans/' + this.model.id + '/groups', curGroup);
                }
            }

            this.sweetAlert.swal(this.locale.getString('seatplans.seatplans.messages.edited'), this.locale.getString('seatplans.seatplans.messages.edited_message'), 'success');
            this.cancel();
        }, (response) => {
            this.error.checkError(response);
        });
    }

    cancel() {
        if (this.stateParams.store) {
            this.stateParams.store.dispatch('getData');
        }
        this.state.go('app.seatplans.details', {id: this.model.id});
    }

    addGroup() {
        this.groups.push({
            'seatplan_id': this.model.id,
            'title': this.locale.getString('seatplans.seatplans.defaults.group_name')
        });
    }

    removeGroup(group) {
        const indexToDelete = this.groups.indexOf(group);

        if (indexToDelete > -1) {
            this.groupsToDelete.push(group);
            this.groups.splice(indexToDelete, 1);
        }
    }

    updateNavigationInformation() {
        this.navService.setStateParameters('app.seatplans.details', {
            id: this.model.id
        });
        this.navService.setBreadcrumbParameters({
            seatplan_name: this.model.title
        });
        let customs = [
            {
                label: 'General',
                active: (this.currentView === 'general'),
                icon: 'info',
                order: 5,
                action: () => {
                    this.changeView('general');
                }
            },
            {
                label: 'Groups',
                active: (this.currentView === 'groups'),
                icon: 'sitemap',
                order: 10,
                action: () => {
                    this.changeView('groups');
                }
            }
        ];


        this.navService.setSideNavCustoms(_.sortBy(customs, 'order'));
    }

    changeView(newView) {
        this.currentView = newView;
        this.updateNavigationInformation();
    }
}

SeatplansEditCtrl.$inject = [
    '$http',
    'Env',
    'Error',
    '$stateParams',
    '$state',
    'locale',
    'SweetAlert',
    'model',
    'Restangular',
    'NavService'
];

/**
 * @ngdoc object
 * @name templates.controller:TemplatesCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.seatplans')
    .controller('SeatplansEditCtrl', SeatplansEditCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/controllers/seatplans-edit-controller.js